export const CURRENCY = {
    'CAD': 'CAD $',
    'USD': '$',
}